// src/components/AuthGuard.tsx
import { useEffect, type JSX } from 'react';
import keycloak from '../auth/keycloak'; // ✅ import keycloak
import { useAuth } from '../context/AuthProvider';

interface ProtectedRouteProps {
    children: JSX.Element;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { isAuthenticated, isInitialized } = useAuth();

    useEffect(() => {
        if (isInitialized && !isAuthenticated) {
            keycloak.login({ redirectUri: window.location.href }); // ✅ auto-login
        }
    }, [isInitialized, isAuthenticated]);

    // if (!isInitialized) {
    //   return <LoadingScreen />;
    // }

    if (!isAuthenticated) {
        return null; // while login is being triggered
    }

    return children;
};

export default ProtectedRoute;
